export class ImageDropdownItem {
    constructor() {
        this.name = ""
        this.image = ""
        this.originalObject = null
        this.hoverEvent = () => {}
        this.clickEvent = () => {}
    }
}